export default __webpack_public_path__ + "static/media/diamante.12a0a485.png";